import { data } from './data';
import styled from 'styled-components';

const P = styled.p`
    color: #0052FF;
    margin-bottom: 2px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
`
export const Testimonials = () =>{
    return <div className='testimonials'>
        <p className='test-heading'>Our executive team</p>
        <div className='row m-0'>
            {
                data.team.slice(0,3).map((data, index)=>{
                    return <div className='col-md-4 col-sm-11 text-center' key={index}>
                        <div>
                            <img src={data.img} width="150px"/>
                        </div>
                        <P>{data.icon} {data.name}</P>
                        <small className='text-secondary'>{data.jobTitle}</small>
                    </div>
                })
            }
        </div>
        <div className='row m-0 mt-5'>
            {
                data.team.slice(3,5).map((data, index)=>{
                    return <div className='col-md-4 col-sm-11 text-center' key={index}>
                        <div>
                            <img src={data.img} width="150px"/>
                        </div>
                        <P>{data.icon} {data.name}</P>
                        <small className='text-secondary'>{data.jobTitle}</small>
                    </div>
                })
            }
        </div>
    </div>
}